const DateOnly = { weekday: "long", year: "numeric", month: "numeric", day: "numeric" };
const DateAndTime = { ...DateOnly, hour: "2-digit", minute: "2-digit", hour12: false };
const unavailable = (date) => [{
  date: date instanceof Date && !Number.isNaN(date.getTime()) ? date : new Date(),
  content: "ProtocolMismatch",
  description: "These prep instructions need to be confirmed with your care team before use.",
  options: DateOnly,
}];

export function buildConfiguredProtocolSteps(procedureDate, procedureTime, protocol, concentrate, doctorId) {
  if (!protocol) return null;
  const prep = (concentrate || "").split(",")[0].trim().toLowerCase();
  const time = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(procedureTime || "");
  const invalid = !Array.isArray(protocol.steps) || !protocol.steps.length ||
    protocol.prepName?.trim().toLowerCase() !== prep ||
    String(protocol.doctorId) !== String(doctorId) ||
    !(procedureDate instanceof Date) || Number.isNaN(procedureDate.getTime()) ||
    !time || Number(time[1]) > 23 || Number(time[2]) > 59;
  if (invalid) return unavailable(procedureDate);
  const appointment = new Date(procedureDate);
  appointment.setHours(Number(time[1]), Number(time[2]), 0, 0);

  const steps = protocol.steps.map((step, index) => {
    let date;
    let exactTime = true;
    if (step.anchor === "hoursBefore" && Number.isInteger(step.hoursBefore) &&
        step.hoursBefore >= 1 && step.hoursBefore <= 72) {
      date = new Date(appointment.getTime() - step.hoursBefore * 60 * 60 * 1000);
    } else if (step.anchor === "daysBefore" && Number.isInteger(step.daysBefore) &&
        step.daysBefore >= 0 && step.daysBefore <= 14) {
      date = new Date(procedureDate);
      date.setDate(date.getDate() - step.daysBefore);
      if (step.time) {
        if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(step.time)) return null;
        const [hours, minutes] = step.time.split(":").map(Number);
        date.setHours(hours, minutes, 0, 0);
      } else {
        exactTime = false;
      }
    } else {
      return null;
    }
    if (typeof step.text !== "string" || !step.text.trim()) return null;
    return {
      date,
      content: `ProtocolStep${index}`,
      description: step.text,
      options: exactTime ? DateAndTime : DateOnly,
      exactTime,
    };
  });
  return steps.some((step) => step == null) ? unavailable(procedureDate) : steps;
}
